import { render, staticRenderFns } from "./DotIcon.vue?vue&type=template&id=0305f27e"
import script from "./DotIcon.vue?vue&type=script&lang=js"
export * from "./DotIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports